import styled, { css } from 'styled-components';
import POPOVER_POSITIONS from '../../../constants/POPOVER_POSITIONS';

interface ContainerProps {
  top: number;
  left: number;
  position: POPOVER_POSITIONS;
}

const gettriangleCss = (props: ContainerProps) => {
  const { position } = props;

  if (position === POPOVER_POSITIONS.RIGHT) {
    return css`
      top: 50%;
      right: 100%;
      bottom: 50%;
      left: auto;
      margin-top: -8px;
      border-color: transparent #fff transparent transparent;
    `;
  }

  if (position === POPOVER_POSITIONS.LEFT) {
    return css`
      top: 50%;
      right: auto;
      bottom: 50%;
      left: 100%;
      margin-top: -8px;
      border-color: transparent transparent transparent #fff;
    `;
  }

  if (position === POPOVER_POSITIONS.BOTTOM) {
    return css`
      top: auto;
      right: 50%;
      bottom: 100%;
      left: 50%;
      margin-left: -8px;
      border-color: transparent transparent #fff transparent;
    `;
  }

  return css`
    top: 100%;
    right: 50%;
    bottom: auto;
    left: 50%;
    margin-left: -8px;
    border-color: #fff transparent transparent;
  `;
};

export const Container = styled.div<ContainerProps>`
  position: absolute;
  left: -99999px;
  top: 0;
  padding: 16px;
  color: #000;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 14px 34px rgba(34, 35, 46, 0.25);
  z-index: 99;
  min-width: 120px;
  max-width: 220px;
  pointer-events: none;
  user-select: none;

  ${({ theme: { isRtl } }) =>
    isRtl &&
    css`
      left: unset;
      right: -99999px;
    `}

  &::before {
    content: '';
    width: 0px;
    height: 0px;
    display: block;
    position: absolute;
    overflow: hidden;
    border-width: 8px;
    border-style: solid;
    z-index: 2;
    ${gettriangleCss};
  }
`;

export const Title = styled.div`
  margin: 0 0 4px;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  white-space: nowrap;
`;

export const Subtitle = styled.div<{ isCategory?: boolean }>`
  font-weight: ${(props) => (props.isCategory ? 400 : 600)};
  font-size: 14px;
  line-height: 16px;
  color: ${(props) => (props.isCategory ? 'rgba(21, 16, 53, 0.4)' : 'inherit')};
`;

export const Info = styled.div`
  margin-top: 4px;
`;

export const Text = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;

export const PriceValue = styled.span`
  &:not(:last-child)::after {
    content: ', ';
    margin-right: 3px;
  }
`;

export const Icons = styled.div`
  display: flex;
  margin-left: 16px;
`;

export const StatusIcon = styled.div`
  ${({ theme: { isRtl } }) =>
    isRtl
      ? css`
          &:not(:last-child) {
            margin-right: 4px;
          }
        `
      : css`
          &:not(:first-child) {
            margin-left: 4px;
          }
        `}
`;

export const LandingInfo = styled.div``;

export const LandingFooterWrapper = styled.div`
  display: flex;
  margin-top: 8px;
  justify-content: space-between;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
